import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage'
import { useCallback, useState } from 'react'
import { FileRejection, useDropzone } from 'react-dropzone'
import { UseFormSetValue } from 'react-hook-form'
import { storage } from '../firebase'
import { Entry } from './form'
import tick from '../assets/images/tick.svg'
import upload from '../assets/images/upload.svg'
import formStyles from '../assets/scss/components/form.module.scss'
import styles from '../assets/scss/components/dropzone.module.scss'

export const Dropzone: React.FC<{ setValue: UseFormSetValue<Entry> }> = ({ setValue }) => {
  const [fileName, setFileName] = useState('')
  const [progress, setProgress] = useState('0%')

  const onDropAccepted = useCallback(
    (files: File[]) => {
      const [file] = files
      const date = new Date()
      const storageRef = ref(storage, `/entries/${date.getTime()}_${file.name}`)
      const uploadTask = uploadBytesResumable(storageRef, file)

      uploadTask.on(
        'state_changed',
        (snapshot) => setProgress(`${(snapshot.bytesTransferred / snapshot.totalBytes) * 100}%`),
        console.error,
        async () => {
          const downloadUrl = await getDownloadURL(uploadTask.snapshot.ref)
          setValue('file', downloadUrl)
          setFileName(file.name)
        },
      )
    },
    [setValue],
  )

  const { fileRejections, getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: {
      'image/*': ['.jpeg', '.jpg', '.png'],
    },
    maxFiles: 1,
    maxSize: 10000000,
    multiple: false,
    onDropAccepted,
  })

  return (
    <div className={formStyles.field}>
      <label>Want to upload a drawing? (optional)</label>
      <div className={styles.dropzone} {...getRootProps()}>
        <input tabIndex={8} {...getInputProps()} />
        <img alt="" className={styles.upload} src={upload} />
        <div className={styles.statusBar}>
          <div className={styles.status}>{isDragActive ? 'Drop file here' : 'Select file'}</div>
          <div className={styles.progress} style={{ width: progress }} />
        </div>
      </div>
      <div className={styles.help}>10mb max. file size. JPG and PNG only.</div>
      <AcceptedFiles fileName={fileName} />
      <FileRejections fileRejections={fileRejections} />
    </div>
  )
}

const AcceptedFiles: React.FC<{ fileName: string }> = ({ fileName }) => {
  if (!fileName) {
    return null
  }

  return (
    <div className={styles.success}>
      {fileName}
      <img alt="" className={styles.tick} src={tick} />
    </div>
  )
}

const FileRejections: React.FC<{ fileRejections: FileRejection[] }> = ({ fileRejections }) => {
  if (!fileRejections.length) {
    return null
  }

  if (!fileRejections[0].errors.length) {
    return null
  }

  return <div className={formStyles.error}>{fileRejections[0].errors[0].message}</div>
}
